module.exports = __webpack_public_path__ + "static/dark-2503819da0965c5c9972688bb9f2f88e.png";